// Udhyak — API client (JWT via localStorage)
const BASE = process.env.REACT_APP_BACKEND_URL;

const TOKEN_KEY = "udhyak_token";
const USER_KEY = "udhyak_user";

export const auth = {
  get token() { return localStorage.getItem(TOKEN_KEY); },
  get user() { try { return JSON.parse(localStorage.getItem(USER_KEY) || "null"); } catch { return null; } },
  set(token, user) {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  },
  updateUser(user) { localStorage.setItem(USER_KEY, JSON.stringify(user)); },
  clear() { localStorage.removeItem(TOKEN_KEY); localStorage.removeItem(USER_KEY); },
};

async function request(path, { method = "GET", body, authed = false } = {}) {
  const headers = { "Content-Type": "application/json" };
  if (authed) {
    const t = auth.token;
    if (t) headers["Authorization"] = `Bearer ${t}`;
  }
  const res = await fetch(`${BASE}/api${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  if (res.status === 401 && authed) {
    auth.clear();
  }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const msg = data?.detail || data?.message || `Request failed (${res.status})`;
    throw new Error(msg);
  }
  return data;
}

export const api = {
  // Auth
  requestOtp: (phone, role) => request("/auth/request-otp", { method: "POST", body: { phone, role } }),
  verifyOtp: (phone, otp, role) => request("/auth/verify-otp", { method: "POST", body: { phone, otp, role } }),
  adminLogin: (email, password) => request("/auth/admin-login", { method: "POST", body: { email, password } }),
  me: () => request("/auth/me", { authed: true }),

  // Customer
  updateCustomerProfile: (data) => request("/customer/profile", { method: "PUT", body: { data }, authed: true }),
  myPatents: () => request("/customer/patents", { authed: true }),
  submitPatent: (payload) => request("/customer/patents", { method: "POST", body: payload, authed: true }),

  // Public attorneys
  listAttorneys: (params = {}) => {
    const q = new URLSearchParams(params).toString();
    return request(`/attorneys${q ? `?${q}` : ""}`);
  },
  getAttorney: (id) => request(`/attorneys/${id}`),

  // Attorney dashboard
  attorneyProfile: () => request("/attorney/profile", { authed: true }),
  updateAttorneyProfile: (data) => request("/attorney/profile", { method: "PUT", body: { data }, authed: true }),
  attorneyLeads: () => request("/attorney/leads", { authed: true }),

  // Admin
  adminStats: () => request("/admin/stats", { authed: true }),
  adminLeads: () => request("/admin/leads", { authed: true }),
  adminAssignLead: (leadId, attorneyId) => request(`/admin/leads/${leadId}/assign`, { method: "POST", body: { attorney_id: attorneyId }, authed: true }),
  adminAttorneys: () => request("/admin/attorneys", { authed: true }),
  adminApprovals: () => request("/admin/approvals", { authed: true }),
  approveAttorney: (id) => request(`/admin/approvals/${id}/approve`, { method: "POST", authed: true }),
  rejectAttorney: (id) => request(`/admin/approvals/${id}/reject`, { method: "POST", authed: true }),
};
